module.exports = __webpack_public_path__ + "static/media/promptpay_icon.64a658c7.png";